@if (errorTxt()?.length>0) {
  <div class="alert alert-danger mt-2" role="alert">
    {{errorTxt()}}
  </div>
}

@if (hasDataErrors()) {
  <div class="alert alert-danger mt-2" role="alert">
    {{ normalized().dataErrors }}
  </div>
}

<!-- CLient Response -->
@if (isValidationResponse()) {
  <div class="alert alert-danger mt-2 p-3">
    <h4>Error List</h4>
    <ul class="mb-1">
      @for (msg of normalized().errMsg; track msg) {
        <li>{{msg}}</li>
      }
    </ul>
  </div>
  @if (hasInfoMessage()) {
    <div class="alert alert-warning mt p-3">
      <h4>Warning List</h4>
      <ul class="mb-1">
        @for (w of normalized().infoMsg; track w) {
          <li>{{w}}</li>
        }
      </ul>
    </div>
  }
}
